const VehicleETA = {
    validHeader: {
        'Vehicle Number': 'vehicle_number',
        'Depot Reference Id': 'depot_reference_id',
        'ETA': 'eta',
    },
    optionalHeader:{},
};

module.exports = { VehicleETA };
